import './dom-11141778.js';
import { i as isUndefined } from './isUndefined-f78f2fdc.js';

/**
 * Determines whether the `value` is `null` or `undefined`.
 */
const isNil = value => {
  return isNull(value) || isUndefined(value);
};

/**
 * Determines whether the `value` is `null`.
 */
const isNull = value => {
  return value === null;
};

export { isNull as a, isNil as i };
